/* eslint-disable */
export default {
  copyToClipboard: '클립보드에 복사',
} as const;

// @key: @#@"copyToClipboard"@#@ @source: @#@"Copy to Clipboard"@#@
